import { render, staticRenderFns } from "./employmentStatusList.vue?vue&type=template&id=4e919846"
import script from "./employmentStatusList.vue?vue&type=script&lang=js"
export * from "./employmentStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports